<template>
  <h1>clebrities</h1>
</template>

<script>
export default {};
</script>

<style>
</style>